CustomTC.define('modules/core',["modules/core-library", "modules/config", "FlashDetect/FlashDetect", "modules/logger", "tooltipster/js/jquery.tooltipster", "tooltipster/js/jquery.tooltipster.display", "css!tooltipster/css/tooltipster"],
    function(CustomTCJQ, config, Clipboard, logger) {
        window.FlashDetect = FlashDetect;
        return {
            clipboard: null,
            hls: null,
            // get element
            init: function(ele) {
                return CustomTCJQ(ele);
            },
            // extend
            extend: function(target, obj, extObj) {
                return CustomTCJQ.extend(target, obj, extObj);
            },
            //clone elem
            clone: function(elem) {
                return elem.clone();
            },
            // find elem
            find: function(target, ele) {
                return target.find(ele);
            },
            // first elem
            first: function(target) {
                return target.first();
            },
            // add class
            addClass: function(ele, className) {
                ele.addClass(className);
            },
            // remove class
            removeClass: function(ele, className) {
                ele.removeClass(className);
            },
            // has class
            hasClass: function(ele, className) {
                return ele.hasClass(className);
            },
            // prev all
            prevAll: function(ele, until, selector) {
                return ele.prevAll(until, selector);
            },
            // next all
            nextAll: function(ele, until, selector) {
                return ele.nextAll(until, selector);
            },
            // prepend html
            prepend: function(ele, html) {
                ele.prepend(html);
            },
            // append html
            append: function(ele, html) {
                ele.append(html);
            },
            // has target
            has: function(ele, target) {
                return ele.has(target);
            },
            // after element
            after: function(ele, html) {
                ele.after(html);
            },
            // before  element
            before: function(ele, html) {
                ele.before(html);
            },
            // closest  element
            closest: function(ele, search) {
                return ele.closest(search);
            },
            // each
            each: function(obj, callback) {
                CustomTCJQ.each(obj, callback);
            },
            // ajax
            ajax: function(obj) {
                CustomTCJQ.ajax(obj);
            },
            // get
            get: function(url, callback) {
                return CustomTCJQ.get(url, callback);
            },
            // get json
            getJSON: function(url, callback) {
                return CustomTCJQ.getJSON(url, callback);
            },
            // parse xml
            parseXML: function(xml) {
                return CustomTCJQ.parseXML(xml);
            },
            // parse json
            parseJSON: function(json) {
                return CustomTCJQ.parseJSON(json);
            },
            // check in array
            inArray: function(value, array) {
                return CustomTCJQ.inArray(value, array);
            },
            // check is array
            isArray: function(array) {
                return CustomTCJQ.isArray(array);
            },
            isEmptyObject: function(obj) {
                return CustomTCJQ.isEmptyObject(obj);
            },
            // check is  object
            isObject: function(obj) {
                if ((typeof obj === "object") && (obj !== null)) {
                    return true;
                } else {
                    return false;
                }
            },
            // get attr
            getAttr: function(ele, attribute) {
                return ele.attr(attribute)
            },
            // set attr
            setAttr: function(ele, attribute, value) {
                ele.attr(attribute, value)
            },
            // remove attr
            removeAttr: function(ele, attribute) {
                ele.removeAttr(attribute)
            },
            // get prop
            getProp: function(ele, attribute) {
                return ele.prop(attribute);
            },
            // set prop
            setProp: function(ele, attribute, value) {
                ele.prop(attribute, value);
            },
            // get val
            getVal: function(ele) {
                return ele.val();
            },
            // set val
            setVal: function(ele, value) {
                ele.val(value);
            },
            // get data
            getData: function(ele, attribute) {
                return ele.data(attribute);
            },
            // is
            is: function(ele, type) {
                return ele.is(type);
            },
            // trim
            trim: function(val) {
                return CustomTCJQ.trim(val);
            },
            // get window width
            getWindowWidth: function() {
                return CustomTCJQ(window).width();
            },
            // get window heightt
            getWindowHeight: function() {
                return CustomTCJQ(window).height();
            },
            //animate
            animate: function(ele, obj) {
                ele.animate(obj);
            },
            // get css
            getCss: function(ele, cssProp) {
                return ele.css(cssProp);
            },
            // change css
            setCss: function(ele, obj) {
                ele.css(obj);
            },
            // resize
            resize: function(ele, handle, data, callback) {
                ele.on(handle + '.CustomTC', data, callback);
            },
            // on
            on: function(ele, handle, callback) {
                ele.on(handle + '.CustomTC', callback);
            },
            //off
            off: function(ele, obj) {
                ele.off(obj + '.CustomTC');
            },
            // one
            one: function(ele, handle, callback) {
                ele.one(handle + '.CustomTC', callback);
            },
            // delay
            delay: function(ele, value) {
                ele.delay(value);
            },
            // fade in element
            fadeIn: function(ele, speed, fn) {
                ele.fadeIn(speed, fn);
            },
            // fade out element
            fadeOut: function(ele, speed, fn) {
                ele.fadeOut(speed, fn);
            },
            // show element
            show: function(ele) {
                ele.show();
            },
            // hide element
            hide: function(ele) {
                ele.hide();
            },
            // remove element 
            remove: function(ele) {
                ele.remove();
            },
            // empty element
            empty: function(ele) {
                ele.empty();
            },
            // set html
            html: function(ele, html) {
                if (typeof(html) !== 'undefined') {
                    ele.html(html);
                } else
                    return ele.html();
            },
            // get width of element
            getWidth: function(ele) {
                return ele.width();
            },
            // get height of element
            getHeight: function(ele) {
                return ele.height();
            },
            // get inner width of element
            getInnerWidth: function(ele) {
                return ele.innerWidth();
            },
            getInnerHeight: function(ele) {
                return ele.innerHeight();
            },
            // get length
            length: function(ele) {
                return ele.length;
            },
            // trigger event
            triggerEvent: function(name, detail) {
                return this.init(window).trigger(name, "[" + detail + "]");
            },
            // trigger
            trigger: function(ele, event) {
                return ele.trigger(event);
            },
            // scroll top
            scrollTop: function(ele, value) {
                if (typeof(value) !== 'undefined')
                    ele.scrollTop(value);
                else
                    return ele.scrollTop();
            },
            // outer height
            outerHeight: function(ele) {
                return ele.outerHeight();
            },
            // slideDown
            slideDown: function(ele) {
                return ele.slideDown();
            },
            // focus
            focus: function(ele, callback) {
                return ele.focus(callback);
            },
            // tooltipster
            tooltipster: function(ele, options, value) {
                try {
                    if (value)
                        ele.tooltipster(options, value);
                    else if (typeof options === 'object' || (typeof options === 'string' && !value))
                        ele.tooltipster(options);
                } catch (err) {
                    console.error(err);
                }
            },
            copyClipboard: function(ele, options, text) {
                if (window.Clipboard) {
                    var self = this;
                    if (text) {
                        this.clipboard = new window.Clipboard(ele, {
                            text: text
                        });
                    } else {
                        this.clipboard = new window.Clipboard(ele, {
                            target: options.copy
                        });
                    }
                    this.clipboard.on('beforecopy', options.beforeCopy);
                    this.clipboard.on('success', options.afterCopy);
                    this.clipboard.on('error', options.onError);
                    return true;
                } else {
                    return false;
                }
            },
            destroyClipboard: function() {
                if (this.clipboard !== null) {
                    this.clipboard.destroy();
                    this.clipboard = null;
                }
            },
            setHls: function() {
                if (window.Hls) {
                    if (window.Hls.isSupported()) {
                        this.hls = new window.Hls({
                            debug: logger
                        });
                        return true;
                    } else {
                        return false;
                    }
                } else {
                    return false;
                }
            },
            getHls: function() {
                return this.hls;
            },
            Event: CustomTCJQ.Event
        }
    });
